<template>
	<div class="auto-complete">
		<input v-model="query" @focus="focusInput" @blur="blurInput"
				:placeholder="$attrs.placeholder" :class="{invalid}">
		<div v-show="showOptions" class="options">
			<div v-for="option in listedOptions" :key="key(option)"
				:class="{active: key(value) === key(option)}"
				class="option" @mousedown="select(option);">
				{{label(option)}}
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['value', 'options', 'trackBy', 'labelBy', 'invalid'],
	data() {
		return {
			showOptions: false,
			query: this.value ? this.label(this.value) : "",
			selected: this.value,
		};
	},
	asyncComputed: {
		async listedOptions() {
			if (!this.query) return [];
			if (this.options instanceof Function) {
				let res = this.options(this.query);
				return res instanceof Promise ? await res : res;
			}
			return this.options;
		},
	},
	methods: {
		key(option) { return (option || {})[this.trackBy]; },
		label(option) { return (option || {})[this.labelBy]; },
		select(option) {
			this.selected = this.key(option) !==  this.key(this.value) ? option : undefined;
			this.$emit('input', this.selected);
		},
		focusInput() {
			this.showOptions = true;
			this.query = '';
		},
		blurInput() {
			if (this.selected) {
				this.query = this.label(this.selected);
				this.$emit('search', '');
			}
			this.showOptions = false;
		},
		clear() {
			this.selected = this.value;
			this.query = '';
			this.showOptions = false;
		}
	}
}
</script>

<style scoped lang="scss">
.auto-complete {
	position: relative;
}
input {
	display: block;
	width: 100%;
	box-sizing: border-box;
	border: 1px solid grey;
}
.options {
	position: absolute;
	background-color: white;
	width: 100%;
	max-height: 300px;
	overflow-y: auto;
	z-index: 2;
}
.option {
	padding: 2px 6px;
	font-size: 12px;
	font-weight: bold;
	cursor: default;
	z-index: 3;
	&:hover {
		background-color: #ccc;
	}
}
.active {
	background-color: #ccc;
}
.invalid {
	border: 1px solid red;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/Autocomplete.vue